import { STRING } from '@/plugins/sdk/fields'
import isString from 'lodash/isString'

export default {
  label: 'Contains',
  operator: 'contains',
  fields: [ STRING ],
  isValidValue (value) {
    return isString(value) && value.length
  }
}
